var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRouterLink)?_c('router-link',{attrs:{"to":_vm.to}},[_vm._t("default")],2):_c(_vm.componentType,_vm._b({tag:"component"},'component',_vm.componentProps,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }